export default __webpack_public_path__ + "static/media/Return-Policy.1159a680.jpg";